import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';
import { ButtonLanding, MinLoader } from 'components';
import { LandingSvg, Svg } from 'assets';
import { animationParams, animationVariants } from 'fragments';

import axios from 'axios';
import { firstBlock, secondBlock, socialMediaIcons, thirdBlock } from './constants';

export const Footer = () => {
    const [loader, setLoader] = useState(false);
    const { handleSubmit, register, reset } = useForm();
    const location = useLocation();
    const navigate = useNavigate();

    const d = new Date();
    const year = d.getFullYear();

    function onSubmit(data) {
        setLoader(true);
        axios
            .post('https://rresdx/fd', data)
            .then(() => {
                setLoader(false);
                toast('Your email was sent');
                reset();
            })
            .catch(() => {
                setLoader(false);
                toast('Something went wrong');
            });
    }

    return (
        <footer className={`footer-wrapper ${location.pathname === '/about-us' ? 'footer-wrapper-about-us' : ''}`}>
            {/*<motion.div*/}
            {/*    className="footer-wrapper-background"*/}
            {/*    {...animationParams}*/}
            {/*    variants={animationVariants.footerBackground}*/}
            {/*/>*/}
            <div className="container">
                <div className="footer-box">
                    <div className="footer-blocks">
                        <div className="footer-icon-social-block">
                            <div>
                                <p className="footer-therapy-icon">TherapyLake</p>
                                <p className="footer-therapy-icon-sub" style={{ marginTop: 15 }}>
                                    The all-in-one ABA practice management platform designed to streamline your operations and improve
                                    clinical outcomes
                                </p>
                            </div>

                            <div className="flex-align-center" style={{ gap: 16, marginTop: 30 }}>
                                {socialMediaIcons.map(({ Icon, path }, index) => (
                                    <div className="footer-social-box" key={index}>
                                        <a
                                            href={path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="footer-info-block-social-icon"
                                        >
                                            <Icon className="footer-info-block-social_svg" />
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="space-between-flex-start" style={{ gap: 32, flexWrap: 'wrap' }}>
                            <div className="footer-block-item">
                                <p className="footer-list-title" style={{ marginBottom: 6 }}>Product</p>
                                {firstBlock.map(({ title, path, target }, index) => (
                                    target === '_blank' ?
                                        <a href={path} target={target} className="footer-block-item_text" key={index}>
                                            {title}
                                        </a>
                                        :
                                        <Link to={path} className="footer-block-item_text" key={index}>
                                            {title}
                                        </Link>
                                ))}
                            </div>

                            <div className="footer-block-item">
                                <p className="footer-list-title" style={{ marginBottom: 6 }}>Company</p>
                                {secondBlock.map(({ title, path }, index) => (
                                    <Link to={path} className="footer-block-item_text" key={index}>
                                        {title}
                                    </Link>
                                ))}
                            </div>

                            <div className="footer-block-item">
                                <p className="footer-list-title" style={{ marginBottom: 6 }}>Support</p>
                                {thirdBlock.map(({ title, path, ...data }, index) => !data?.target ? (
                                            <Link to={path} className="footer-block-item_text" key={index}>
                                                {title}
                                            </Link>
                                        )
                                        :
                                        (
                                            <a
                                                href={path}
                                                target={data?.target}
                                                rel="noopener noreferrer"
                                                className="footer-block-item_text"
                                                key={index}
                                            >
                                                {title}
                                            </a>
                                        ),
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="footer-info-block">
                        <div className="footer-info-block-terms">
                            <p className="footer-therapy-icon-sub">© {year} - TherapyLake. All rights reserved.</p>
                            <div className="flex-align-center" style={{ gap: 24 }}>
                                <Link to="/terms-and-conditions" className="footer-info-block-terms-text">
                                    Terms & Conditions
                                </Link>
                                <Link to="/privacy-policy" className="footer-info-block-terms-text">
                                    Privacy Policy
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
